module.exports = __webpack_public_path__ + "assets/img/5_1193.6bdec5e9.jpg";